interface IConfig {
  visitor?: {
    name: string;
  };
}

declare const CONFIG: IConfig;

export const VISITOR = CONFIG.visitor;
